module.exports = __webpack_public_path__ + "static/media/stop-loop.0f7b77e7.svg";